const menuOpen = "hdr-menu-open";

export function init(element) {
	element.addEventListener("click", _ => document.body.classList.toggle(menuOpen));
}
